import 'lib-flexible/flexible.js';
import 'url-search-params-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import ViewUI from 'view-design';
import VueClipboard from 'vue-clipboard2';
import 'view-design/dist/styles/iview.css';
import './style/theme.less';
import 'vue2-animate/dist/vue2-animate.min.css';

import App from './App.vue';
import router from './router';
import store from '../src/store';
import { trackPageView } from './utils/track/baidu_statistics';
import navBtn from './components/layout/navBtn.vue';
import Currency from './components/basics/Currency.vue';
import Empty from './components/basics/Empty.vue';
import PhoneInput from './components/basics/PhoneInput.vue';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueRouter from 'vue-router';

import 'swiper/swiper-bundle.css';
import { saveChannelId, saveCustomId } from './common';
import sessionStorage from './utils/storage/sessionStorage';
import localStorage from './utils/storage/localStorage';
import {
  getEnvironment,
  isPCBrowser,
  is3mHost,
  formatMoney,
  isTaitanHost
} from './utils/index';
import config from './config';
import './utils/plugin.js'; // 防止连点自定义指令
import { getChannel } from './service/index';
// 改版背景走马灯
import RefBg from './components/layout/revisionBackground.vue';

import tags from '@/components/basics/tags.vue';

// vantPC
import '@vant/touch-emulator';
// 标签
Vue.component('tags', tags);

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

//iview的走马灯数据改变时有bug，使用elementui的走马灯
import { Carousel, CarouselItem, Cascader } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { SHA256 } from 'crypto-js';

import Loading from '@/components/basics/Loading';

// 注：原这里把裸 axios 挂到 Vue.prototype（this.axios）供组件直用，
// 现已收口到请求唯一出口 src/lib/request/createHttpService.js，不再暴露全局 axios
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);

Vue.config.productionTip = false;
Vue.use(Vuex)
  .use(VueClipboard)
  .use(ViewUI)
  .use(Loading);

// 金额展示格式化（只用于呈现）：模板里直接 {{ $formatMoney(price) }}，
// 需要固定两位小数时 {{ $formatMoney(price, 2) }}
Vue.prototype.$formatMoney = formatMoney;

Vue.component('NavBtn', navBtn);
Vue.component('Currency', Currency);
Vue.component('Empty', Empty);
Vue.component('RefBg', RefBg);
// 手机号输入（只允许数字 + 锁 11 位），全站统一用这个
Vue.component('PhoneInput', PhoneInput);
// md5引入;
if (!window.md5) {
  window.md5 = str => {
    if (typeof str !== 'string') {
      str = JSON.stringify(str);
    }
    // 使用SHA-256计算哈希值
    const hash = SHA256(str).toString();

    return hash;
  };
}
function loadBreadcrumbFromSessionStorage() {
  const breadcrumbItems = sessionStorage.get('breadcrumb');
  if (breadcrumbItems && breadcrumbItems.length) {
    sessionStorage.set('breadcrumb', breadcrumbItems);
    store.commit('common/setBreadcrumbItem', {
      payload: breadcrumbItems
    });
  }
}

loadBreadcrumbFromSessionStorage();

// 兼容旧路径：/birthday2 是 h5 新版生日专区的路由，PC 上由 /birthday 承载 —— 两者是同一个页面
// （views/birthday/index.vue），但 /birthday 下还挂着品牌详情 / 商品列表 / 适用门店等子路由，
// 并且 index.vue 里 is_3m 遇到 /birthday2 会直接显示「请用手机微信扫码进入专属平台」的提示。
// 所以凡是落到 /birthday2 的跳转都在这里改道（接口下发的 banner 链接、频道切换、直接输网址…都覆盖），
// 子路径按同名尾巴平移（/birthday2/list → /birthday/list），query / hash 原样保留。
// 注册在最前面：重定向会中止本次导航，不会为 /birthday2 记一次上报或面包屑。
const BIRTHDAY_ALIAS = '/birthday2';
router.beforeEach((to, from, next) => {
  const { path, query, hash } = to;
  if (path === BIRTHDAY_ALIAS || path.indexOf(BIRTHDAY_ALIAS + '/') === 0) {
    next({
      path: '/birthday' + path.slice(BIRTHDAY_ALIAS.length),
      query,
      hash,
      replace: true
    });
    return;
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (is3mHost()) {
    return window.location.replace(
      'https://mall.pandayoufu.com/custom_home?custom_id=806'
    );
  }
  if (isTaitanHost()) {
    return window.location.replace(
      'https://mall.pandayoufu.com/custom_home?custom_id=66'
    );
  }
  if (!isPCBrowser()) {
    return window.location.replace('https://mall.pandayoufu.com');
  }
  mapping(to, from, next);
  trackPageView(to.fullPath);
  breadFn(to);
  // const breadcrumbItems = store.state.common.breadcrumbItem;
  // const targetIndex = breadcrumbItems.findIndex(item => item.path === to.path);
  // let payload = {
  //   path: to.path,
  //   fullPath: to.fullPath,
  //   meta: to.meta,
  //   name: to.name
  // };
  // if (targetIndex > 0) {
  //   breadcrumbItems.length = targetIndex + 1;
  //   payload = breadcrumbItems;
  // }
  // store.commit('common/setBreadcrumbItem', {
  //   payload,
  //   callback: breadcrumbItems => {
  //     sessionStorage.set('breadcrumb', breadcrumbItems);
  //   }
  // });
  // test
  let userInfo = localStorage.get('session_info');
  if ((!userInfo || !userInfo.token) && to.path.indexOf('login') == -1) {
    return next('/login?redirect_url=' + encodeURIComponent(location.href));
  }
  if (to.path == '/') {
    let host = window.location.host;
    if (
      host === 'pcmall.pandayoufu.com' ||
      host === 'www.pandayoufu.com' ||
      host === 'pcmall-test.pandayoufu.com'
    ) {
      getChannel()
        .then(data => {
          let res = data.modules;
          next(res[0].url);
        })
        .catch(() => {
          next('/mall?channel_id=10');
        });
    } else if (host === '3m.pandayoufu.com') {
      next('/home?custom_id=362');
    } else if (is3mHost(host)) {
      next('/partition?mode=exchange&channel_id=2137&custom_id=806');
    } else if (process.env.NODE_ENV === 'development') {
      next('/home');
    } else {
      let userInfo = localStorage.get('session_info');
      if (userInfo) {
        getChannel()
          .then(data => {
            let res = data.modules;
            next(res[0].url);
          })
          .catch(() => {
            next('/mall?channel_id=10');
          });
      } else {
        next('/login');
      }
    }
  } else {
    next();
  }
});

// 公众号-PC 路由映射
function mapping() {
  let mappingArr = config.routeMapping;
  let env = getEnvironment();
  let href = window.location.href;
  if (env == 1) {
    let exit = mappingArr.some(item => {
      return item.pc == href;
    });
    // 若跳转的链接存在路由映射表中，则跳转
    if (exit) {
      mappingArr.map(item => {
        if (item.pc == href) {
          window.location.href = item.mobile;
        }
      });
    } else {
      sessionStorage.set('show_app', true);
    }
  } else {
    sessionStorage.set('show_app', true);
  }
}

// 面包屑
function breadFn(to) {
  let bread = sessionStorage.get('bread');
  //如果去往的是各首页，先清空面包屑
  let homes = [
    '/',
    '/mall',
    '/movie',
    '/movie/film',
    '/movie/cinema',
    '/tour',
    '/lucky_wheel',
    '/activity',
    '/customization',
    '/festival_channel',
    '/birthday',
    '/live_service',
    '/life_privilege'
  ];
  let ishome = homes.some(item => {
    return item == to.path;
  });
  if (ishome) {
    bread = [];
  }
  // 没有面包屑或面包屑数组为空
  if (!bread || (bread.length && bread.length == 0)) {
    bread = [
      {
        fullPath: to.fullPath,
        path: to.path,
        meta: to.meta
      }
    ];
  } else {
    // 有面包屑则添加
    // 已经在这条轨迹里（例如从详情页返回列表页）：把它后面的「未来项」截掉。
    // 否则轨迹最后一项不是当前页，面包屑上就会出现一个「点了没反应」的格子
    // （那一格其实正是当前路由，router.push 到同地址会被判定为重复导航）
    const targetIndex = bread.findIndex(item => item.fullPath == to.fullPath);
    if (targetIndex > -1) {
      bread = bread.slice(0, targetIndex + 1);
    } else {
      bread.push({
        fullPath: to.fullPath,
        path: to.path,
        meta: to.meta
      });
      if (bread.length >= 5) {
        // 面包屑最多显示最近4个
        bread.splice(1, 1);
      }
      //个人中心3个路由只保留一个
      let latestUserCenterRoute = bread
        .filter(route => route.path.includes('/userCenter'))
        .pop();
      bread = bread.filter(route => !route.path.includes('/userCenter'));
      if (latestUserCenterRoute) bread.push(latestUserCenterRoute);

      // 同标题只保留一条（如多个商品详情）：保留首次出现的位置，
      // 但这一条要换成「当前路由」，否则轨迹最后一项指向的还是上一件商品
      if (bread.length > 1) {
        const sameTitleFirstIndex = bread.findIndex(
          item => item.meta.title === to.meta.title
        );
        const sameTitleCount = bread.filter(
          item => item.meta.title === to.meta.title
        ).length;
        if (sameTitleFirstIndex != -1 && sameTitleCount > 1) {
          bread = [
            ...bread.slice(0, sameTitleFirstIndex),
            bread[bread.length - 1]
          ];
        }
      }
    }
  }
  bread = bread.filter(item => {
    return item.path !== '/' && item.path !== '/login';
  });
  sessionStorage.set('bread', bread);
}

router.afterEach(to => {
  const { channel_id, custom_id } = to.query || {};
  saveChannelId(channel_id);
  saveCustomId(custom_id);
});

//判断去往个人中心时的登录状态
router.beforeEach((to, from, next) => {
  if (to.name == 'cards') {
    let info = localStorage.get('session_info');
    if (!info) {
      window.setTimeout(() => {
        next({
          path: '/login'
        });
      }, 2000);
    } else {
      next();
    }
  }
  next();
});

// 解决路由冗余
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location);
};

// 路由跳转使重置滚动条到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
